import React, { useState } from 'react';

const Chevron = ({ open }) => <svg className={`lp-disc-chev ${open ? 'open' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>;

const FEATURES = [
    { t: '73 structured questions', d: 'covering all 17 Core Disclosure sections, legally reviewed for completeness' },
    { t: '60% autofill', d: 'platform pre-populates responses from your Data Repository automatically' },
    { t: 'AI Analyser', d: 'checks responses against FCA standards, flags gaps before submission' },
    { t: 'Consistency checking', d: 'cross-disclosure analysis identifies contradictions across sections' },
    { t: 'Risk scoring', d: 'each question scored to highlight areas requiring board attention' },
    { t: "Director's Certification", d: 'formal sign-off built into the module — no separate paperwork' },
    { t: 'Window-over-window', d: 'prior disclosures carry forward; only material changes need updating' },
    { t: 'Hard gates', d: 'CD7 (director trading intentions) and CD12 (major shareholders) cannot be omitted' },
];

const CDS = [
    { num: 'CD 1', t: 'Business Overview', d: "Description of the company's business, products/services, and markets." },
    { num: 'CD 2', t: 'Management Overview', d: 'Details of directors, senior management, and their relevant experience.' },
    { num: 'CD 3', t: 'Financial Information', d: 'Key financial statements and commentary on financial performance.' },
    { num: 'CD 4', t: 'Capital Structure and Ownership', d: 'Share capital, ownership structure, and controlling interests.' },
    { num: 'CD 5', t: 'Share Information', d: 'Classes of shares, voting rights, and transfer restrictions.' },
    { num: 'CD 6', t: 'Employee Share Scheme', d: 'Details of any employee share incentive or option schemes.' },
    { num: 'CD 7', t: "Directors' Transactions", d: "Disclosure of directors' intentions to buy or sell shares in the trading window.", hardGate: true },
    { num: 'CD 8', t: 'Material Contracts', d: "Summary of contracts material to the company's business." },
    { num: 'CD 9', t: 'Previous Share Capital Raises', d: 'History of equity fundraising and valuation at each round.' },
    { num: 'CD 10', t: 'Risk Factors', d: 'Principal risks and uncertainties facing the company.' },
    { num: 'CD 11', t: 'Significant Changes', d: 'Material developments since the last set of published financial information.' },
    { num: 'CD 12', t: 'Major Shareholders', d: 'Shareholders holding 5% or more of any class of shares.', hardGate: true },
    { num: 'CD 13', t: 'Price Parameters', d: 'The price range within which the company is willing to accept orders.' },
    { num: 'CD 14', t: 'Future Trading Events', d: 'Dates of planned future trading windows, if known.' },
    { num: 'CD 15', t: 'Last Auction', d: 'Results of the most recent trading window auction.' },
    { num: 'CD 16', t: 'Related Party Transactions', d: 'Transactions with directors, major shareholders, or connected persons.' },
    { num: 'CD 17', t: 'Contact Details', d: 'Company contact information for buyer enquiries.' },
];

const PiscesDisclosureModule = () => {
    const [modOpen, setModOpen] = useState(true);
    const [cdOpen, setCdOpen] = useState(true);
    const [openCD, setOpenCD] = useState(null);

    return (
        <section className="lp-disc-sec">
            <div className="lp-prob-head">
                <div className="lp-eyebrow" data-lp-reveal><span className="lp-ww-eyebrow">The Disclosure Module</span></div>
                <h2 className="lp-h2" data-lp-reveal data-lp-delay="60" style={{ fontSize: '35px', maxWidth: '1200px' }}>73 questions. All 17 Core Disclosures. Nothing missed.</h2>
                <p className="lp-prob-lead" data-lp-reveal data-lp-delay="120">Structured against PS 2.3.2R and the LSE PSM Appendix 2 framework — the same standards your operator uses for admission assessment. Not a general-purpose questionnaire.</p>
            </div>

            <div className="lp-disc-cols">
                <div className="lp-disc-col" data-lp-reveal>
                    <button className="lp-disc-head" onClick={() => setModOpen(o => !o)}>
                        <h3>Module features</h3>
                        <Chevron open={modOpen} />
                    </button>
                    {modOpen && (
                        <div className="lp-disc-rows">
                            {FEATURES.map((f, i) => (
                                <div className="lp-disc-row" key={i}><strong>{f.t}</strong><span>{f.d}</span></div>
                            ))}
                        </div>
                    )}
                </div>

                <div className="lp-disc-col" data-lp-reveal data-lp-delay="120">
                    <button className="lp-disc-head lp-disc-head--blue" onClick={() => setCdOpen(o => !o)}>
                        <h3>All 17 FCA Core Disclosures</h3>
                        <Chevron open={cdOpen} />
                    </button>
                    {cdOpen && (
                        <div className="lp-disc-acc">
                            <p className="lp-disc-hint">Click any section to expand</p>
                            {CDS.map((cd, i) => (
                                <div className="lp-disc-item" key={i}>
                                    <button className="lp-disc-itemhead" onClick={() => setOpenCD(openCD === i ? null : i)}>
                                        <span className="lp-disc-itemhead-l">
                                            <span className="num">{cd.num}</span>
                                            <span className="ttl">{cd.t}</span>
                                            {cd.hardGate && <span className="gate">HARD GATE</span>}
                                        </span>
                                        <Chevron open={openCD === i} />
                                    </button>
                                    {openCD === i && <p className="lp-disc-itembody">{cd.d}</p>}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default PiscesDisclosureModule;
